export default __webpack_public_path__ + "static/media/CPTSpath.533a7bf4.png";